import { ApiBaseCustomer } from './base';

export class ApiCustomerGE extends ApiBaseCustomer {
  getAccountWithHistory(id: number) {
    return this.get(`/ge/customer/account/${id}`);
  }
}
